import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dp",
  "use": "icon-dp-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-dp\"><defs><style type=\"text/css\"></style></defs><path d=\"M844.672 903.232 179.2 903.232c-102.848 0-144.768-71.104-93.056-158.08l332.608-559.232C470.4 99.008 554.944 99.072 606.528 186.048l331.456 559.04C989.504 832.064 947.52 903.232 844.672 903.232zM512 274.944c-27.776 0-50.24 22.528-50.24 50.24l25.152 326.72 50.24 0 25.152-326.72C562.24 297.408 539.776 274.944 512 274.944zM512 702.208c-27.776 0-50.24 22.528-50.24 50.24S484.224 802.688 512 802.688s50.24-22.528 50.24-50.24S539.776 702.208 512 702.208z\" p-id=\"10765\" fill=\"#f38f38\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dp.svg
// module id = +BKk
// module chunks = 32